const KEY = "takepay_device_id";

export const getDeviceId = (): string => {
  if (typeof window === "undefined") return "server";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `dev_${crypto.randomUUID()}`;
    localStorage.setItem(KEY, id);
  }
  return id;
};
